import { render, staticRenderFns } from "./ImportOrdersTableAllUser.vue?vue&type=template&id=051a9a66&scoped=true"
import script from "./ImportOrdersTableAllUser.vue?vue&type=script&lang=js"
export * from "./ImportOrdersTableAllUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051a9a66",
  null
  
)

export default component.exports